// routeHelpers.js (ou markerHelpers.js si tu veux tout regrouper)
export function cleanRoute(routesObj, markersArray, routeId, abortController) {
  console.log(
    '🚀 ~ cleanRoute ~ routesObj, markersArray, routeId, abortController:',
    routesObj,
    markersArray,
    routeId,
    abortController,
  )

  // Nettoyer la route principale et tous ses segments
  if (routeId) {
    // Supprimer la route principale
    if (routesObj[routeId]) delete routesObj[routeId]

    // Supprimer tous les segments de cette route
    Object.keys(routesObj).forEach(key => {
      if (key.startsWith(routeId)) {
        delete routesObj[key]
      }
    })
  }

  if (routeId && markersArray?.length) {
    for (let i = markersArray.length - 1; i >= 0; i--) {
      if (markersArray[i].routeId === routeId) markersArray.splice(i, 1)
    }
  }

  if (abortController) abortController.abort()
}
